import { AirUrlParams } from 'hooks/useAirNavigation';
import * as RangeWithIdList from 'types/_general/Search/RangeWithIdList';
import * as SliderWithId from 'types/_general/Search/SliderWithId';

export type Type = SliderWithId.Type[];

export function create(): Type {
	return [];
}

export function mapToApi(obj: Type) {
	let output = {};
	const nutrientRanges: RangeWithIdList.Type = [];
	obj.forEach((x) => {
		switch (x.id) {
			case 'calories':
				output = {
					...output,
					caloriesRange: { minimum: x.left, maximum: x.right },
				};
				break;
			case 'co2':
				output = {
					...output,
					carbonDioxideRange: { minimum: x.left, maximum: x.right },
				};
				break;
			default:
				nutrientRanges.push({ id: x.id, minimum: x.left, maximum: x.right });
				break;
		}
	});
	output = {
		...output,
		nutrientRanges: nutrientRanges,
	};
	return output;
}

export function mapToUrl(obj: Type): string {
	const array: string[] = [];
	obj.forEach((x) => {
		array.push(`${x.id}:${x.left}:${x.right}`);
	});
	return array.join(';');
}

export function mapFromUrl(params: AirUrlParams, urlKey: string): Type {
	const output: Type = [];
	const urlList: string | undefined = params[urlKey];

	if (!urlList) return output;

	const temp: string[] = urlList.split(';');

	temp.forEach((x) => {
		const split = x.split(':');
		output.push({
			id: split[0],
			left: Number(split[1]),
			right: Number(split[2]),
		});
	});

	return output;
}

export function getById(obj: Type, id: string): SliderWithId.Type {
	const output = obj.find((x) => x.id === id);
	if (output) return output;
	return SliderWithId.create();
}
